/* eslint react/require-default-props: off */
import React, { forwardRef } from 'react';
import { string, shape, number } from 'prop-types';
import { Box } from '@leagueplatform/genesis-core';
import { HealthProgramsCard } from './health-programs-card.component';
import { programsListPropType } from '../utils/health-programs-page.props';

export const HealthProgramsGallery = forwardRef(
  (
    {
      programs = [],
      analyticsContext = { pageContext: undefined, programCategory: undefined },
      firstNewProgramIndex,
    },
    ref,
  ) => (
    <Box css={{ display: 'flex', flexWrap: 'wrap' }} as="ul">
      {programs.length > 0 &&
        programs.map((program, index) => {
          const isFirstNewProgram = index === firstNewProgramIndex;

          return (
            <Box
              as="li"
              key={program.program_id}
              css={{
                width: 'fit-content',
                margin: '$threeQuarters',
              }}
            >
              <HealthProgramsCard
                program={program}
                analyticsContext={analyticsContext}
                ref={isFirstNewProgram ? ref : undefined}
              />
            </Box>
          );
        })}
    </Box>
  ),
);

HealthProgramsGallery.propTypes = {
  programs: programsListPropType,
  analyticsContext: shape({ programCategory: string, pageContext: string }),
  firstNewProgramIndex: number.isRequired,
};
